import { useMemo } from 'react';

import * as dealResource from 'resources/deal/hooks';
import * as userResource from 'resources/user/hooks';
import * as companyResource from 'resources/company/hooks';

import * as companyHelpers from 'resources/company/company.helpers';

const isTest = false;

const useSubscriptionLimitation = () => {
  const { isLoading: isUserLoading, data: user } = userResource.useCurrentUser();

  const {
    isLoading: isCompanyLoading, data: company,
  } = companyResource.useCompany(user?.company_id, { enabled: !!user?.id });
  const {
    isLoading: isDealsLoading, data: deals,
  } = dealResource.useDealsByCompanyId(
    { companyId: user?.company_id, userId: user?.id },
    { enabled: !!user?.id },
  );

  const isSampleDeal = deals?.every((deal) => deal.is_sample);
  const otherDeals = deals?.filter((deal) => !deal.is_sample);

  const isSubscribed = companyHelpers.isSubscribed(company);
  const isSubscriptionCanceled = companyHelpers.isSubscriptionCanceled(company);
  const isTrialing = companyHelpers.isTrialing(company);

  const hasNoDeals = !otherDeals || otherDeals?.length === 0;
  const hasSingleDeal = !!otherDeals && otherDeals?.length === 1;

  const isViewTransactionAvailable = useMemo(() => {
    if (isSubscriptionCanceled) return false;

    if (isSubscribed) return true;

    if (isSampleDeal) return true;

    if (isTrialing) return true;

    if (!isSubscribed && hasSingleDeal) return true;
  }, [isSubscriptionCanceled, isSubscribed, isSampleDeal, isTrialing, hasSingleDeal]);

  const isCreateNewTransactionAvailable = useMemo(() => {
    if (isSubscribed) return true;

    if (isSubscriptionCanceled) return false;

    if (isSampleDeal) return true;

    if (isTrialing) return true;

    if (!isSubscribed && hasNoDeals) return true;
  }, [isSubscribed, isSubscriptionCanceled, isSampleDeal, isTrialing, hasNoDeals]);

  const isSubscriptionStatusLoading = useMemo(
    () => isUserLoading || isCompanyLoading || isDealsLoading,
    [isCompanyLoading, isDealsLoading, isUserLoading],
  );

  return {
    isViewTransactionAvailable: isTest || !!isViewTransactionAvailable,
    isCreateNewTransactionAvailable: isTest || !!isCreateNewTransactionAvailable,
    isSubscriptionStatusLoading,
  };
};

export default useSubscriptionLimitation;
